import * as lib from '~/dependencies';
import colors from '~/layout/colors';

export const Metrics = lib.styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: baseline;
  row-gap: 3px;
  column-gap: 14px;
`;

export const Title = lib.styled.div`
  grid-column: 1 / -1;
  margin-bottom: 5px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
`;

export const Label = lib.styled.span`
  white-space: nowrap;
  font-weight: 600;
`;

export const Value = lib.styled.span`
  justify-self: end;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${colors.darkGray01};
`;
